import { Paragraph } from "docx"

export function simpleParagraphs(name, content) {
    return [new Paragraph({ text: name, style: "title" }), new Paragraph({ text: content, style: "bold" })]
}
